import styled from "styled-components";
import { useState } from "react";
import { IFontProps, TEcoSystemGuide } from "@/typings/Props";
import { theme } from "@/styles/theme";
import { media } from "@/styles/media";
import EcoSystemModal from "@/components/learn/EcoSystemModal";

export default function Spot(props: TEcoSystemGuide) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <SpotWrapper $x={`${props.coord.x}`} $y={`${props.coord.y}`} onClick={() => setIsModalOpen(true)}>
        <PulseSpot />
        <DescWrapper>
          <P $fontColor={theme.colors.primary} $fontSize="1.5rem" $lineHeight="130%">
            {props.title}
          </P>
          <P $fontColor={theme.colors.text.grayLight} $lineHeight="150%" $fontSize="0.9rem">
            {props.desc}
          </P>
        </DescWrapper>
        <Circle style={{ fontSize: typeof props.id === "string" ? 25 : "0.9rem" }}>{props.id}</Circle>
      </SpotWrapper>
      <EcoSystemModal props={props} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}></EcoSystemModal>
    </>
  );
}

const Circle = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  border-radius: 20px;
  text-align: center;
  font-size: 0.9rem;
  cursor: pointer;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.text.white};
  ${media.tablet`
    width: 25px;
    height: 25px;
    font-size: 0.7rem;
  `}
`;
const DescWrapper = styled.div`
  position: absolute;
  bottom: 70px;
  width: 250px;
  height: auto;
  display: block;
  margin: 0 0 0 -105px;
  padding: 20px;
  border-radius: 10px;
  z-index: 1;
  opacity: 0;
  pointer-events: none;
  transition: 0.3s ease-out;
  background-color: ${theme.colors.background.white};
  ${media.tabletNarrow`
    display: none;
  `}
`;

const P = styled.p<IFontProps>`
  font-size: ${(props) => props.$fontSize};
  font-weight: ${(props) => props.$fontWeight};
  line-height: ${(props) => props.$lineHeight};
  color: ${(props) => props.$fontColor};
  margin-top: ${(props) => props.$marginTop};
  white-space: pre-wrap;
`;

const PulseSpot = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${theme.colors.primary};
  transform: translate(-50%, -50%);
  animation: pulseKeyFrames 3s ease-out infinite;
  z-index: 0;

  @keyframes pulseKeyFrames {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.7;
    }
    30% {
      transform: translate(-50%, -50%) scale(1.5);
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
`;

const SpotWrapper = styled.div<{ $x: string; $y: string }>`
  position: absolute;
  left: ${({ $x }) => $x};
  top: ${({ $y }) => $y};

  &:hover {
    ${DescWrapper} {
      opacity: 1;
      transition: 0.3s ease-out;
    }
  }
`;
